import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const HeadlineFooter = ({ blok }) => (
  <div className="headlinefooter-wrap" {...storyblokEditable(blok)}>
    <h1 className="text-3xl headlinefooter-headline">{blok.headline}</h1>
  </div>
);

export default HeadlineFooter;
